module.exports = "/assets/side-events-hero-mobile.png?1LMNZG1";